import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { MethodsService } from 'src/app/services/methods.service';
import { InteractionsService } from 'src/app/services/interactions.service';

@Component({
  selector: 'app-new-scratch',
  templateUrl: './new-scratch.component.html',
  styleUrls: ['./new-scratch.component.scss']
})
export class NewScratchComponent implements OnInit, OnDestroy {

  @Input('interactionId') interactionId;
  private interactionsSubscriber;
  public interaction;
  private isDrawing
  private lastPoint;
  private container;
  private canvas;
  private canvasWidth;
  private canvasHeight;
  private ctx;
  public image = new Image();
  private brush = new Image();
  public canShow = false;
  public language = 'it'
  constructor(
    private methods: MethodsService,
    private interactionsService: InteractionsService
  ) {
    this.language = localStorage.getItem('l')
  }


  ngOnInit(): void {
    this.container = document.getElementById('js-container');
    this.canvas = document.getElementById('js-canvas');
    this.canvasWidth  = this.canvas.width;
    this.canvasHeight = this.canvas.height;

    this.interactionsSubscriber = this.interactionsService.interactions$.subscribe(interactions => {
      this.interaction = interactions.filter(interaction => interaction.id === this.interactionId)[0];
      this.methods.get('assets/data/'+this.language +'/' + this.interaction.content.configId + '.config.json').subscribe( config => {
        this.interaction.config = config;
        this.image.src = this.interaction.config.imageForwardSrc;
        this.brush.src = 'assets/images/default/brush.png';
        if (!this.interaction.completed.onComplete) {
          this.setCanvasImage(config);
        }
      });
    });

    this.canvas.addEventListener('mousedown', this.handleMouseDown.bind(this), false);
    this.canvas.addEventListener('touchstart', this.handleMouseDown.bind(this), false);
    this.canvas.addEventListener('mousemove', this.handleMouseMove.bind(this), false);
    this.canvas.addEventListener('touchmove', this.handleMouseMove.bind(this), false);
    this.canvas.addEventListener('mouseup', this.handleMouseUp.bind(this), false);
    this.canvas.addEventListener('touchend', this.handleMouseUp.bind(this), false);
  }

  setCanvasImage(config) {
    // TODO: look down
    setTimeout ( () => {
      this.container.appendChild(this.canvas);
      this.ctx = this.canvas.getContext('2d');
      // canvas usage --> https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/globalCompositeOperation
      this.ctx.globalCompositeOperation = 'source-over'; // maybe an await here can resolve.
      this.ctx.drawImage(this.image, 0, 0, config.containerWidth, config.containerHeight);
      this.canShow = true;
    }, 1000);
  }

  distanceBetween(point1, point2) {
    return Math.sqrt(Math.pow(point2.x - point1.x, 2) + Math.pow(point2.y - point1.y, 2));
  }

  angleBetween(point1, point2) {
    return Math.atan2( point2.x - point1.x, point2.y - point1.y );
  }

  // Only test every `stride` pixel. `stride`x faster,
  // but might lead to inaccuracy
  getFilledInPixels(stride) {
    if (!stride || stride < 1) { stride = 1; }

    const pixels   = this.ctx.getImageData(0, 0, this.canvasWidth, this.canvasHeight);
    const pdata    = pixels.data;
    const l        = pdata.length;
    const total    = (l / stride);
    let count    = 0;

    // console.log('pdata', pdata);

    // Iterate over all pixels
    for (let i = count = 0; i < l; i += stride) {
      if (parseInt(pdata[i]) === 0 ) {
        count++;
      }
    }

    // Es. (600/1000) * 100 = 60
    return Math.round((count / total) * 100);
  }

  getMouse(e, canvas) {
    let offsetX = 0;
    let offsetY = 0;
    let mx;
    let my;

    if (canvas.offsetParent !== undefined) {
      do {
        offsetX += canvas.offsetLeft;
        offsetY += canvas.offsetTop;
      } while ((canvas = canvas.offsetParent));
    }

    mx = (e.pageX || e.touches[0].clientX) - offsetX;
    my = (e.pageY || e.touches[0].clientY) - offsetY;

    return {x: mx, y: my};
  }

  handlePercentage(filledInPixels) {
    filledInPixels = filledInPixels || 0;
    if (filledInPixels > 90 && this.canvas.parentNode) {
      // this.canvas.style.opacity = 0;
      this.canvas.parentNode.removeChild(this.canvas);
      this.interaction.completed = {
        onComplete: true,
        status: 'success'
      };
      this.interactionsService.setCompleted(this.interaction);
      this.interactionsService.updateInteraction(this.interaction);
    }
  }

  handleMouseDown(e) {
    this.isDrawing = true;
    this.lastPoint = () => {
      let offsetX = 0;
      let offsetY = 0;
      let mx;
      let my;

      if (this.canvas.offsetParent !== undefined) {
        do {
          offsetX += this.canvas.offsetLeft;
          offsetY += this.canvas.offsetTop;
        } while ((this.canvas = this.canvas.offsetParent));
      }

      mx = (e.pageX || e.touches[0].clientX) - offsetX;
      my = (e.pageY || e.touches[0].clientY) - offsetY;

      return {x: mx, y: my};
      };
  }

  handleMouseMove(e) {
    if (!this.isDrawing || this.interaction.completed.onComplete) { return; }
    e.preventDefault();

    let currentPoint = this.getMouse(e, this.canvas);
    let dist = this.distanceBetween(this.lastPoint, currentPoint);
    let angle = this.angleBetween(this.lastPoint, currentPoint);
    let x;
    let y;

    for (let i = 0; i < dist; i++) {
      x = this.lastPoint.x + (Math.sin(angle) * i) - 25;
      y = this.lastPoint.y + (Math.cos(angle) * i) - 25;
      this.ctx.globalCompositeOperation = 'destination-out';
      this.ctx.drawImage(this.brush, x, y);
    }

    this.lastPoint = currentPoint;
    this.handlePercentage(this.getFilledInPixels(32));
  }

  handleMouseUp(e) {
    this.isDrawing = false;
  }

  ngOnDestroy() {

  }

}
